/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'slots-on-phone': {
    width: 10,
    height: 10,
    viewBox: '0 0 10 10',
    data: '<path pid="0" d="M4.616 1.64c-.462 0-.462-.692 0-.692A4.32 4.32 0 018.945 5.27c0 .462-.661.462-.661 0 0-2.013-1.652-3.63-3.668-3.63zM.882 3.786S.585 2.862.75 1.97c.132-.859.595-1.189.727-1.288.132-.066.33-.197.33-.197s.231-.231.496.066C2.567.816 3.79 2.07 3.79 2.07s.23.264.033.528c-.198.23-.893.924-.893.924.298 1.122 2.313 3.136 3.437 3.433 0 0 .693-.66.958-.859.231-.198.495.033.495.033s1.256 1.189 1.553 1.453c.265.297.033.495.033.495s-.099.23-.198.33c-.066.132-.43.594-1.288.76C7.06 9.297 6.102 9 6.102 9 4.12 8.21 1.674 5.8.882 3.786zm4.329-.561c-.43 0-.43-.693 0-.693 1.19 0 2.148.957 2.148 2.145 0 .462-.694.462-.694 0 0-.792-.66-1.452-1.454-1.452z" _fill="#FFF" fill-rule="evenodd"/>'
  }
})
